import axios from "infra/http";
import { useQuery } from "react-query";
import { EnderecoDto } from 'core/features/unidades/typings/unidade';

function useClienteEndereco(id?: string) {
  return useQuery(
    `/v1/cliente/${id}/endereco`,
    async () => {
      const res = await axios.get<EnderecoDto>(`/v1/cliente/${id}/endereco`);

      return res.data;
    },
    {
      enabled: !!id,
    }
  );
}

export default useClienteEndereco;
